const form = {
  formId: "param-month36-form",
  formField: {
    ASQ3Communication_CutoffLB: {
      name: "ASQ3Communication_CutoffLB",
      label: "ASQ3 Communication: BLACK (<=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    ASQ3Communication_CutoffUB: {
      name: "ASQ3Communication_CutoffUB",
      label: "ASQ3 Communication: WHITE (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is required.",
    },
    ASQ3GrossMotor_CutoffLB: {
      name: "ASQ3GrossMotor_CutoffLB",
      label: "ASQ3 Gross Motor: BLACK (<=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    ASQ3GrossMotor_CutoffUB: {
      name: "ASQ3GrossMotor_CutoffUB",
      label: "ASQ3 Gross Motor: WHITE (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is required.",
    },
    ASQ3FineMotor_CutoffLB: {
      name: "ASQ3FineMotor_CutoffLB",
      label: "ASQ3 Fine Motor: BLACK (<=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    ASQ3FineMotor_CutoffUB: {
      name: "ASQ3FineMotor_CutoffUB",
      label: "ASQ3 Fine Motor: WHITE (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is required.",
    },
    ASQ3ProblemSolving_CutoffLB: {
      name: "ASQ3ProblemSolving_CutoffLB",
      label: "ASQ3 Problem Solving: BLACK (<=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    ASQ3ProblemSolving_CutoffUB: {
      name: "ASQ3ProblemSolving_CutoffUB",
      label: "ASQ3 Problem Solving: WHITE (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is required.",
    },
    ASQ3PersonalSocial_CutoffLB: {
      name: "ASQ3PersonalSocial_CutoffLB",
      label: "ASQ3 Personal Social: BLACK (<=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    ASQ3PersonalSocial_CutoffUB: {
      name: "ASQ3PersonalSocial_CutoffUB",
      label: "ASQ3 Personal Social: WHITE (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is required.",
    },
    ASQ3_SE2_CutoffLB: {
      name: "ASQ3_SE2_CutoffLB",
      label: "ASQ3-SE2: WHITE (<=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    ASQ3_SE2_CutoffUB: {
      name: "ASQ3_SE2_CutoffUB",
      label: "ASQ3-SE2: BLACK (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_Total_CutoffB1: {
      name: "SDQ_Total_CutoffB1",
      label: "VERY HIGH (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_Total_CutoffB2: {
      name: "SDQ_Total_CutoffB2",
      label: "HIGH (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_Total_CutoffB3: {
      name: "SDQ_Total_CutoffB3",
      label: "SLIGHTLY RAISED (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_EmotionalProb_CutoffB1: {
      name: "SDQ_EmotionalProb_CutoffB1",
      label: "VERY HIGH (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_EmotionalProb_CutoffB2: {
      name: "SDQ_EmotionalProb_CutoffB2",
      label: "HIGH (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_EmotionalProb_CutoffB3: {
      name: "SDQ_EmotionalProb_CutoffB3",
      label: "SLIGHTLY RAISED (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_ConductProb_CutoffB1: {
      name: "SDQ_ConductProb_CutoffB1",
      label: "VERY HIGH (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_ConductProb_CutoffB2: {
      name: "SDQ_ConductProb_CutoffB2",
      label: "HIGH (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_ConductProb_CutoffB3: {
      name: "SDQ_ConductProb_CutoffB3",
      label: "SLIGHTLY RAISED (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_Hyperactivity_CutoffB1: {
      name: "SDQ_Hyperactivity_CutoffB1",
      label: "VERY HIGH (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_Hyperactivity_CutoffB2: {
      name: "SDQ_Hyperactivity_CutoffB2",
      label: "HIGH (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_Hyperactivity_CutoffB3: {
      name: "SDQ_Hyperactivity_CutoffB3",
      label: "SLIGHTLY RAISED (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_PeerProb_CutoffB1: {
      name: "SDQ_PeerProb_CutoffB1",
      label: "VERY HIGH (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_PeerProb_CutoffB2: {
      name: "SDQ_PeerProb_CutoffB2",
      label: "HIGH (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_PeerProb_CutoffB3: {
      name: "SDQ_PeerProb_CutoffB3",
      label: "SLIGHTLY RAISED (>=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_Prosocial_CutoffB1: {
      name: "SDQ_Prosocial_CutoffB1",
      label: "VERY LOW (<=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_Prosocial_CutoffB2: {
      name: "SDQ_Prosocial_CutoffB2",
      label: "LOW (<=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
    SDQ_Prosocial_CutoffB3: {
      name: "SDQ_Prosocial_CutoffB3",
      label: "SLIGHTLY LOWERED (<=)",
      type: "text",
      errorMsg: "Cutoff value is required.",
      invalidMsg: "Cutoff value is invalid.",
    },
  },
};

export { form as default };
